(function () {
  'use strict';

  if (customElements.get('recently-viewed')) return;

  customElements.define('recently-viewed', class RecentlyViewed extends HTMLElement {
    constructor() {
      super();
      this.section = this.closest('related-products');
      this.sectionId = this.section?.dataset.sectionId;
      this.howManyToShow = parseInt(this.dataset.limit) || 3;
      this.hasLoaded = false;
    }

    connectedCallback() {
      if (this.hasLoaded) return;

      if (!this.section || this.section.dataset.lazyActive === 'true') {
        this.loadRecentlyViewed();
        return;
      }

      this.section.addEventListener('theme:related-products:activate', () => {
        this.loadRecentlyViewed();
      }, { once: true });
    }

    loadRecentlyViewed() {
      if (this.hasLoaded) return;
      this.hasLoaded = true;

      Shopify.Products.showRecentlyViewed({
        howManyToShow: this.howManyToShow,
        wrapperId: `recently-viewed-products-${this.sectionId}`,
        section: this.section,
        onComplete: (wrapper) => {
          wrapper.parentElement.dispatchEvent(new CustomEvent('theme:recently-viewed:loaded', {
            bubbles: false
          }));
        }
      });
    }
  });
})();
